import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/StoreContext';
import { SQIcon } from '@/components/ui/SQIcon';
import styles from './ConnectionStatus.module.css';

export const ConnectionStatus = observer(function ConnectionStatus() {
  const { ui } = useStore();
  const banner = ui.connectionBanner;
  if (!banner) return null;

  return (
    <div
      className={styles.bar}
      data-state={banner}
      role="status"
      aria-live="polite"
    >
      <span className={styles.inner}>
        {banner === 'offline' && (
          <>
            <SQIcon name="wifi-off" size={16} aria-hidden />
            <span>Соединение потеряно</span>
            <button
              className={styles.reconnect}
              onClick={() => void ui.requestReconnect()}
            >
              Переподключиться
            </button>
          </>
        )}
        {banner === 'reconnecting' && (
          <>
            <span className={styles.dots} aria-hidden>
              <span /><span /><span />
            </span>
            <span>Переподключаемся…</span>
          </>
        )}
        {banner === 'restored' && (
          <>
            <span className={styles.checkGlyph} aria-hidden>✓</span>
            <span>Связь восстановлена</span>
          </>
        )}
      </span>
    </div>
  );
});
